import React, { createContext, useContext, useState, useCallback } from 'react'

interface OverlayContextValue {
  monthId: string | null
  receiptId: number | null
  openMonth: (monthId: string) => void
  closeMonth: () => void
  openReceipt: (receiptId: number) => void
  closeReceipt: () => void
}

const OverlayContext = createContext<OverlayContextValue | null>(null)

export const OverlayProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [monthId, setMonthId] = useState<string | null>(null)
  const [receiptId, setReceiptId] = useState<number | null>(null)

  const openMonth = useCallback((id: string) => setMonthId(id), [])
  const closeMonth = useCallback(() => setMonthId(null), [])
  const openReceipt = useCallback((id: number) => setReceiptId(id), [])
  const closeReceipt = useCallback(() => setReceiptId(null), [])

  return (
    <OverlayContext.Provider value={{ monthId, receiptId, openMonth, closeMonth, openReceipt, closeReceipt }}>
      {children}
    </OverlayContext.Provider>
  )
}

export const useOverlay = (): OverlayContextValue => {
  const ctx = useContext(OverlayContext)
  if (!ctx) throw new Error('useOverlay must be used within OverlayProvider')
  return ctx
}
